<template>
  <div class="login">
    <div class="tab-bar">
      <a class="tab-button" :class="{selected: tabBarSelectedIndex === 0}" @click="setSelectedIndex(0)">Sign up</a>
      <a class="tab-button" :class="{selected: tabBarSelectedIndex === 1}" @click="setSelectedIndex(1)">Log in</a>
    </div>

    <registration v-if="tabBarSelectedIndex === 0"
      v-model="regForm"
      class="login-form"
      :errors="registrationErrors"
      :roles="filteredRoles"
      :locales="filteredLocales"
      @submit="register"
    />

    <login v-if="tabBarSelectedIndex === 1"
      v-model="user"
      class="login-form"
      :errors="loginErrors"
      @submit="login"
    />
  </div>
</template>

<script>
  import Login from 'raypro_ui/src/components/ui/forms/Login_v2'
  import Registration from 'raypro_ui/src/components/ui/forms/Registration_v2'
  import Sprite from 'raypro_ui/src/components/ui/Sprite'
  import page from '@/mixins/page'

  import {getAvailableRoles} from 'raypro_ui/src/api/users'
  import {getLocales} from 'raypro_ui/src/api/locales'
  import {createRegistration} from 'raypro_ui/src/api/registrations'

  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import notificationMixin from 'raypro_ui/src/mixins/systemNotifications'
  import * as onboardingTypes from 'raypro_ui/src/store/modules/onboarding/types'
  import * as httpErrors from 'raypro_ui/src/store/modules/httpRequests/types'

  export default {
    components: {
      Login,
      Registration,
      Sprite,
    },

    mixins: [page, notificationMixin],

    data() {
      return {
        title: 'Login',
        roles: [],
        locales: [],
        user: {},
        regForm: {},
        loginErrors: {},
        registrationErrors: {},
        tabBarSelectedIndex: 0,
      }
    },

    mounted() {
      this.getRoles()
      this.getLocales()
    },

    computed: {
      ...mapGetters(['authUser', 'isAdmin']),

      loginPayload() {
        return {user: this.user}
      },

      registrationPayload() {
        return {
          user: {
            email: this.regForm.email,
            password: this.regForm.password,
            locale_id: this.regForm.locale_id,
            'user_roles': [{'role_id': this.regForm.role}],
            profile: {
              'first_name': this.regForm.first_name,
              'last_name': this.regForm.last_name,
            },
          },
          recaptcha_token: this.regForm.recaptchaToken,
        }
      },

      filteredRoles() {
        const filtered = []
        this.roles.forEach((role) => {
          if (['surgeon', 'nurse'].includes(role.key)) {
            filtered.push(role)
          }
        })

        return filtered
      },

      filteredLocales() {
        const filtered = []
        this.locales.forEach((locale) => {
          if (['English'].includes(locale.key)) {
            filtered.push(locale)
          }
        })

        return filtered
      },
    },

    methods: {
      ...mapActions(['loginUser']),
      ...mapGetters(['isOnboarded']),
      ...mapMutations([onboardingTypes.SYSTEM_NOTIFICATIONS, 'removeFromNotifications']),
      ...mapMutations([httpErrors.SERVER_SHOW_OVERLAY, httpErrors.SERVER_OVERLAY_MESSAGE, httpErrors.SERVER_OVERLAY_FUNCTION]),

      login() {
        this.loginUser(this.loginPayload)
          .then(({user}) => {
            const role = user.roles[0].name

            if (role === 'surgeon') {
              if (this.userIsOnboarded(user)) {
                this.$router.push({name: 'Overview'})
              } else {
                this.$router.push({name: 'hospital-onboarding'})
              }
            } else if (role === 'nurse') {
              this.$router.push({name: 'all-patients'})
            } else {
              this.$router.push({name: 'Overview'})
            }

            this.fetchSystemNotificatons()
          })
          .catch(({response}) => {
            this.errors = response
          })
      },

      register() {
        createRegistration(this.registrationPayload)
          .then(() => {
            this[httpErrors.SERVER_SHOW_OVERLAY]('success')
            this[httpErrors.SERVER_OVERLAY_MESSAGE](this.successMessage)
            this[httpErrors.SERVER_OVERLAY_FUNCTION](() => { this.setSelectedIndex(1) })
          })
          .catch((response) => {
            this.errors = response
          })
      },

      getRoles() {
        getAvailableRoles().then(({data}) => {
          this.roles = data.available_roles.map((role) => {
            return {key: role.name, value: role.id}
          })
        })
      },

      getLocales() {
        getLocales().then(({data}) => {
          this.locales = data.map((locale) => {
            return {key: locale.name, value: locale.id}
          })
        })
      },

      setSelectedIndex(index) {
        this.tabBarSelectedIndex = index
      },

      userIsOnboarded(user) {
        return this.isOnboarded().includes(user.id) || user.hospitals.length > 0
      },
    }
  }
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'
@import '../../../stylesheets/helpers/mixins'
@import '../../../stylesheets/helpers/extends.sass'

.login
  width: 400px
  margin: 30px auto 0 auto
  border-radius: 20px
  background-color: $color-panel-bg

  .tab-bar
    padding: 30px 45px 0 45px
    font-size: 14px
    font-weight: bold
    .tab-button
      color: $color-text
      padding: 5px
      &.selected
        text-decoration: underline

  .login-form
    box-shadow: none
    border-radius: 20px
    padding: 10px 45px 20px 45px
    .input
      .input-wrapper
        padding-top: 15px
      .input-footer
        padding-top: 3px
      &.checkbox
        font-weight: bold
</style>



// WEBPACK FOOTER //
// src/components/pages/Login/Login_v2.vue